import {IFileDataProperties} from '../services/imageDataConverter.service';
import {IOuterNode} from "../../angular2-tree/interfaces/IOuterNode";

export const FILEMANAGER_TREE_NAME = 'fileManagerTree';

export abstract class AbstractFileManagerApiService {

  protected treeName = FILEMANAGER_TREE_NAME;
  protected fileManagerName = 'fileManagerFiles';


  protected nodes: IOuterNode[];
  protected files: IFileDataProperties[];

  public currentNodeId = '';
}
